import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable } from 'rxjs';
import { DataService } from '../../shared/services';
import { map } from 'rxjs/operators';

@Injectable()
export class InspectionInfoFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  updateInspectionInfo(inspectionId: string, pluginId: string, config: any): Observable<any> {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config = config;
            return plugin;
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          plugin.config = config;
        }

        if (!config.StartDate) {
          inspection.startDate = null;
          inspection.endDate = null;
        } else {
          inspection.startDate = config.StartDate;
          inspection.endDate = config.EndDate;
          inspection.duration = config.DefinedDuration;
        }
        plugin.etag = new Date();
        this.updateInspection(inspection);
        return plugin;
      })
    );
  }
}
